import axios from 'axios';
import { getMemberSessionToken } from './sessionAuth';

const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

/**
 * Shared HTTP boundary for the Rastyle frontend.
 *
 * Keep transport defaults here so feature workspaces do not each invent
 * cookie, base URL, timeout, or authentication behavior.
 */
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 30000,
  headers: {
    Accept: 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = getMemberSessionToken();
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Create request configuration for bearer-authenticated platform calls.
 * Empty tokens are intentionally omitted rather than sending `Bearer undefined`.
 */
export function withAuth(token, config = {}) {
  const headers = { ...(config.headers || {}) };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return {
    ...config,
    headers,
  };
}

/**
 * Resolve an API path without duplicating backend URL concatenation.
 * Useful for non-Axios consumers such as EventSource, WebSocket handshakes,
 * redirects, and third-party SDK callbacks.
 */
export function apiUrl(path = '') {
  if (!path) return API_BASE_URL;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export default apiClient;
